import { useEffect, useCallback } from 'react';
import dynamic from 'next/dynamic';
import { PROJECT_FOLDER_PATH } from 'constants/app';
import { EipoPageContainer } from '../../utils/styled';

const IpoPage = dynamic(
  // @ts-ignore
  // eslint-disable-next-line
  () => import('stockbitipo/eipo-detail'),
  {
    ssr: false,
  },
);

interface IEipoPage {
  emiten: any;
  onClickListEmiten: any;
}

const EipoPage = ({ emiten, onClickListEmiten }: IEipoPage) => {
  const onClickIpoChange = (emitenCode: any) => {
    onClickListEmiten(emitenCode);
  };

  const handleClickIPOLink = useCallback((event: CustomEvent) => {
    const data = event?.detail;
    if (data?.url) {
      let fullUrl = data.url;
      if (!fullUrl.startsWith('http://') && !fullUrl.startsWith('https://')) {
        fullUrl = `https://${fullUrl}`;
      }
      window.open(fullUrl, '_blank');
    }
  }, []);

  const handleClickDetailIPO = useCallback((event: CustomEvent) => {
    const data = event?.detail;
    if (typeof window !== 'undefined' && data) {
      window.open(`${PROJECT_FOLDER_PATH}/symbol/${data?.emiten}`, '_blank');
    }
  }, []);

  const handleOpenPDF = useCallback((event: CustomEvent) => {
    const data = event?.detail;
    if (data) {
      window.open(data.url).focus();
    }
  }, []);

  useEffect(() => {
    window.addEventListener(
      'onclickIPOLink',
      handleClickIPOLink as EventListener,
    );
    window.addEventListener('openIPOPdf', handleOpenPDF as EventListener);
    window.addEventListener(
      'onclickDetailIPO',
      handleClickDetailIPO as EventListener,
    );

    return () => {
      window.removeEventListener(
        'onclickIPOLink',
        handleClickIPOLink as EventListener,
      );
      window.removeEventListener('openIPOPdf', handleOpenPDF as EventListener);
      window.removeEventListener(
        'onclickDetailIPO',
        handleClickDetailIPO as EventListener,
      );
    };
  }, [handleClickIPOLink, handleOpenPDF]);

  return (
    <EipoPageContainer>
      <IpoPage
        emitenCode={emiten || ''}
        onClickIpoChange={onClickIpoChange}
        isDark={false}
      />
    </EipoPageContainer>
  );
};

export default EipoPage;
